/**
 * @fileoverview gRPC-Web generated client stub for market
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.28.1
// source: market.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as market_pb from './market_pb'; // proto import: "market.proto"


export class MarketServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetMarkets = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetMarkets',
    grpcWeb.MethodType.UNARY,
    market_pb.GetMarketsRequest,
    market_pb.GetMarketsReply,
    (request: market_pb.GetMarketsRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetMarketsReply.deserializeBinary
  );

  getMarkets(
    request: market_pb.GetMarketsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetMarketsReply>;

  getMarkets(
    request: market_pb.GetMarketsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetMarketsReply) => void): grpcWeb.ClientReadableStream<market_pb.GetMarketsReply>;

  getMarkets(
    request: market_pb.GetMarketsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetMarketsReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetMarkets',
        request,
        metadata || {},
        this.methodDescriptorGetMarkets,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetMarkets',
    request,
    metadata || {},
    this.methodDescriptorGetMarkets);
  }

  methodDescriptorGetMarketsStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetMarketsStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetMarketsRequest,
    market_pb.GetMarketsReply,
    (request: market_pb.GetMarketsRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetMarketsReply.deserializeBinary
  );

  getMarketsStream(
    request: market_pb.GetMarketsRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetMarketsReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetMarketsStream',
      request,
      metadata || {},
      this.methodDescriptorGetMarketsStream);
  }

  methodDescriptorGetMarket = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetMarket',
    grpcWeb.MethodType.UNARY,
    market_pb.GetMarketRequest,
    market_pb.GetMarketReply,
    (request: market_pb.GetMarketRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetMarketReply.deserializeBinary
  );

  getMarket(
    request: market_pb.GetMarketRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetMarketReply>;

  getMarket(
    request: market_pb.GetMarketRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetMarketReply) => void): grpcWeb.ClientReadableStream<market_pb.GetMarketReply>;

  getMarket(
    request: market_pb.GetMarketRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetMarketReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetMarket',
        request,
        metadata || {},
        this.methodDescriptorGetMarket,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetMarket',
    request,
    metadata || {},
    this.methodDescriptorGetMarket);
  }

  methodDescriptorGetMarketStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetMarketStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetMarketRequest,
    market_pb.GetMarketReply,
    (request: market_pb.GetMarketRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetMarketReply.deserializeBinary
  );

  getMarketStream(
    request: market_pb.GetMarketRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetMarketReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetMarketStream',
      request,
      metadata || {},
      this.methodDescriptorGetMarketStream);
  }

  methodDescriptorGetKlines = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetKlines',
    grpcWeb.MethodType.UNARY,
    market_pb.GetKlinesRequest,
    market_pb.GetKlinesReply,
    (request: market_pb.GetKlinesRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetKlinesReply.deserializeBinary
  );

  getKlines(
    request: market_pb.GetKlinesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetKlinesReply>;

  getKlines(
    request: market_pb.GetKlinesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetKlinesReply) => void): grpcWeb.ClientReadableStream<market_pb.GetKlinesReply>;

  getKlines(
    request: market_pb.GetKlinesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetKlinesReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetKlines',
        request,
        metadata || {},
        this.methodDescriptorGetKlines,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetKlines',
    request,
    metadata || {},
    this.methodDescriptorGetKlines);
  }

  methodDescriptorGetKlinesStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetKlinesStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetKlinesRequest,
    market_pb.GetKlinesReply,
    (request: market_pb.GetKlinesRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetKlinesReply.deserializeBinary
  );

  getKlinesStream(
    request: market_pb.GetKlinesRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetKlinesReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetKlinesStream',
      request,
      metadata || {},
      this.methodDescriptorGetKlinesStream);
  }

  methodDescriptorGetHolders = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetHolders',
    grpcWeb.MethodType.UNARY,
    market_pb.GetHoldersRequest,
    market_pb.GetHoldersReply,
    (request: market_pb.GetHoldersRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetHoldersReply.deserializeBinary
  );

  getHolders(
    request: market_pb.GetHoldersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetHoldersReply>;

  getHolders(
    request: market_pb.GetHoldersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetHoldersReply) => void): grpcWeb.ClientReadableStream<market_pb.GetHoldersReply>;

  getHolders(
    request: market_pb.GetHoldersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetHoldersReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetHolders',
        request,
        metadata || {},
        this.methodDescriptorGetHolders,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetHolders',
    request,
    metadata || {},
    this.methodDescriptorGetHolders);
  }

  methodDescriptorGetHoldersStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetHoldersStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetHoldersRequest,
    market_pb.GetHoldersReply,
    (request: market_pb.GetHoldersRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetHoldersReply.deserializeBinary
  );

  getHoldersStream(
    request: market_pb.GetHoldersRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetHoldersReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetHoldersStream',
      request,
      metadata || {},
      this.methodDescriptorGetHoldersStream);
  }

  methodDescriptorGetTransactions = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetTransactions',
    grpcWeb.MethodType.UNARY,
    market_pb.GetTransactionsRequest,
    market_pb.GetTransactionsReply,
    (request: market_pb.GetTransactionsRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetTransactionsReply.deserializeBinary
  );

  getTransactions(
    request: market_pb.GetTransactionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetTransactionsReply>;

  getTransactions(
    request: market_pb.GetTransactionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetTransactionsReply) => void): grpcWeb.ClientReadableStream<market_pb.GetTransactionsReply>;

  getTransactions(
    request: market_pb.GetTransactionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetTransactionsReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetTransactions',
        request,
        metadata || {},
        this.methodDescriptorGetTransactions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetTransactions',
    request,
    metadata || {},
    this.methodDescriptorGetTransactions);
  }

  methodDescriptorGetTransactionsStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetTransactionsStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetTransactionsRequest,
    market_pb.GetTransactionsReply,
    (request: market_pb.GetTransactionsRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetTransactionsReply.deserializeBinary
  );

  getTransactionsStream(
    request: market_pb.GetTransactionsRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetTransactionsReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetTransactionsStream',
      request,
      metadata || {},
      this.methodDescriptorGetTransactionsStream);
  }

  methodDescriptorGetRates = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetRates',
    grpcWeb.MethodType.UNARY,
    market_pb.GetRatesRequest,
    market_pb.GetRatesReply,
    (request: market_pb.GetRatesRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetRatesReply.deserializeBinary
  );

  getRates(
    request: market_pb.GetRatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetRatesReply>;

  getRates(
    request: market_pb.GetRatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetRatesReply) => void): grpcWeb.ClientReadableStream<market_pb.GetRatesReply>;

  getRates(
    request: market_pb.GetRatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetRatesReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetRates',
        request,
        metadata || {},
        this.methodDescriptorGetRates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetRates',
    request,
    metadata || {},
    this.methodDescriptorGetRates);
  }

  methodDescriptorGetRatesStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetRatesStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetRatesRequest,
    market_pb.GetRatesReply,
    (request: market_pb.GetRatesRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetRatesReply.deserializeBinary
  );

  getRatesStream(
    request: market_pb.GetRatesRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetRatesReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetRatesStream',
      request,
      metadata || {},
      this.methodDescriptorGetRatesStream);
  }

  methodDescriptorGetGasPrice = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetGasPrice',
    grpcWeb.MethodType.UNARY,
    market_pb.GetGasPriceRequest,
    market_pb.GetGasPriceReply,
    (request: market_pb.GetGasPriceRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetGasPriceReply.deserializeBinary
  );

  getGasPrice(
    request: market_pb.GetGasPriceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.GetGasPriceReply>;

  getGasPrice(
    request: market_pb.GetGasPriceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.GetGasPriceReply) => void): grpcWeb.ClientReadableStream<market_pb.GetGasPriceReply>;

  getGasPrice(
    request: market_pb.GetGasPriceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.GetGasPriceReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/GetGasPrice',
        request,
        metadata || {},
        this.methodDescriptorGetGasPrice,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/GetGasPrice',
    request,
    metadata || {},
    this.methodDescriptorGetGasPrice);
  }

  methodDescriptorGetGasPriceStream = new grpcWeb.MethodDescriptor(
    '/market.MarketService/GetGasPriceStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    market_pb.GetGasPriceRequest,
    market_pb.GetGasPriceReply,
    (request: market_pb.GetGasPriceRequest) => {
      return request.serializeBinary();
    },
    market_pb.GetGasPriceReply.deserializeBinary
  );

  getGasPriceStream(
    request: market_pb.GetGasPriceRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<market_pb.GetGasPriceReply> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/market.MarketService/GetGasPriceStream',
      request,
      metadata || {},
      this.methodDescriptorGetGasPriceStream);
  }

  methodDescriptorSearchMarkets = new grpcWeb.MethodDescriptor(
    '/market.MarketService/SearchMarkets',
    grpcWeb.MethodType.UNARY,
    market_pb.SearchMarketsRequest,
    market_pb.SearchMarketsReply,
    (request: market_pb.SearchMarketsRequest) => {
      return request.serializeBinary();
    },
    market_pb.SearchMarketsReply.deserializeBinary
  );

  searchMarkets(
    request: market_pb.SearchMarketsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<market_pb.SearchMarketsReply>;

  searchMarkets(
    request: market_pb.SearchMarketsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: market_pb.SearchMarketsReply) => void): grpcWeb.ClientReadableStream<market_pb.SearchMarketsReply>;

  searchMarkets(
    request: market_pb.SearchMarketsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: market_pb.SearchMarketsReply) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/market.MarketService/SearchMarkets',
        request,
        metadata || {},
        this.methodDescriptorSearchMarkets,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/market.MarketService/SearchMarkets',
    request,
    metadata || {},
    this.methodDescriptorSearchMarkets);
  }

}

